define('responsive-pitch-fx/responsive-pitch-fx',['require','exports','module','./lib/PitchLayer'],function(require,exports,module){
    var PitchLayer = require('./lib/PitchLayer');

    return PitchLayer;
});
